const headerNav = document.querySelector('.h-nav');
const main = document.querySelector('main');

/*
  open close dropdown
 */
main.addEventListener('focusin', (e) => {
  _closeAllDropdowns(headerNav);
})
// targets logo
headerNav.previousElementSibling.addEventListener('keyup', (e) => {
  if (e.key === 'Tab') {
    _closeAllDropdowns(headerNav);
  }
});

// targets menu items with no children
headerNav.querySelectorAll('.link > a').forEach(function(v) {
  v.addEventListener('keyup', (e) => {
    if (e.key === 'Tab') {
      _closeAllDropdowns(headerNav);
    }
  })
});

// targets all menu and submenu items
headerNav.querySelectorAll('li > a').forEach(function(v) {
  v.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      _closeAllDropdowns(headerNav);

      e.target.focus(); // after close, focus on self
      const navLink = e.target.parentElement.parentElement.previousElementSibling;
      if (navLink) navLink.focus(); // if submenu item, focus on menu item
    }
  })
});

// targets all menu items
headerNav.querySelectorAll('.dropdown > a').forEach(function(v) {
  v.addEventListener('keyup', (e) => {
    if (e.key === 'Tab') {
      _closeAllDropdowns(headerNav);
      _toggleDropdown(e.target);
      return;
    }
    if (e.key === 'Enter') {
      _toggleDropdown(e.target);
      return;
    }
  })
});

headerNav.querySelectorAll('[role="button"]').forEach(function(v) {
  v.addEventListener('click', (e) => {
    e.preventDefault();
  });
});

/*
  Helper Functions
  */
function _toggleDropdown (target) {
  const p = target.parentElement, n = target.nextElementSibling;
  p.classList.toggle('open');
  _toggleAriaExpanded(p.firstElementChild);

  if (p.classList.contains('open'))
    n.style.display = 'block';
  else
    n.style.display = '';
};

function _toggleAriaExpanded (target) {
  let isExpanded = target.getAttribute('aria-expanded');
  const expandedMap = new Map([['true', 'false'], ['false', 'true']]);
  target.setAttribute('aria-expanded', expandedMap.get(isExpanded));
}

function _closeAllDropdowns (target) {
  const openDropdowns = target.querySelectorAll('.open');
  openDropdowns.forEach(dropdown => {
    _closeDropdown(dropdown.firstElementChild);
  })
};

function _closeDropdown (target) {
  const parent = target.parentElement;
  if (parent.classList.contains('open')) {
    parent.classList.toggle('open');
    target.setAttribute('aria-expanded', 'false');
    target.nextElementSibling.style.display = '';
  }
};
